// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#receive-message-setting[data-v-23d8e331]{max-width:700px;margin-left:auto;margin-right:auto}#receive-message-setting .cancel-btn[data-v-23d8e331],#receive-message-setting .update-btn[data-v-23d8e331]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
